// ─────────────────────────────────────────────────────────────────────────────
// constants.ts — ContentSectionEditPageProduct
// ─────────────────────────────────────────────────────────────────────────────
import { ActiveSection } from './types';

export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];

export const SECTION_HUMAN: Record<ActiveSection, string> = {
  heroSection:    'Hero',
  productSection: 'Product',
  contactSection: 'Contact',
};
export const SECTION_KEY: Record<ActiveSection, string> = {
  heroSection:    'PD-001',
  productSection: 'PD-002',
  contactSection: 'PD-003',
};


export const formatBytes = (bytes: number): string => {
  if (bytes < 1024)        return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};